const host = 'https://d9b54x484lq62.cloudfront.net/newulife/shopping/images/';

export default (str = '') => str.startsWith('http') ? str : `${host}${str}`;